import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { FormSection } from 'redux-form';
import { debounce } from 'throttle-debounce';
import styled from 'styled-components';

import SearchOptions from 'components/StyleSettings/SearchOptions';
import SearchResults from 'components/StyleSettings/SearchResults';
import {
    setPreviewStyleAction,
    clearPreviewStyleAction,
    searchAction,
    searchQuery,
} from 'modules/navigation/stylePanel';
import { getStyle } from 'modules/style';
import { ContentSet } from 'components/Shared/Scaffolding';
import { SCAFFOLDING, TYPOGRAPHY, SECTIONS } from 'theme';
import { LinkButton } from 'components/Shared/Buttons';
import MODAL from 'components/Shared/Modals';
import { showModal } from 'modules/modal';
import { currentUserAuthenticatedSelector } from 'modules/currentUser';
import { SmallLoading } from 'components/Loading/SmallLoading';

const NoResults = styled.div`
    padding-top: ${SCAFFOLDING.GUTTER};
    border-top: 1px solid ${SECTIONS.SUB.BG};
    color: ${TYPOGRAPHY.COLOR_REDUCED};
    font-style: italic;
    text-align: center;
`;

class SearchTab extends React.Component {
    componentDidMount() {
        const styles = this.props.tab.searchResult.styles;
        if (styles === undefined && !this.props.showLoginMessage) {
            this.props.search();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Compare the search queries, ignore the pagination
        if (searchQuery(this.props.tab, 0) !== searchQuery(nextProps.tab, 0)) {
            nextProps.search(0);
        }
    }

    renderLoginMessage() {
        const { onLoginClick, onRegisterClick } = this.props;
        const button = (onClick, text) => (
            <LinkButton type="button" onClick={onClick}>
                {text}
            </LinkButton>
        );
        const login = button(onLoginClick, 'log in');
        const register = button(onRegisterClick, 'register');
        return (
            <NoResults>
                Please {login} or {register} to access your saved styles.
            </NoResults>
        );
    }

    render() {
        const { tab, tabIndex, selectedStyle, showLoginMessage, search, handleStyleSelected, scrollToTop } = this.props;
        return (
            <FormSection name={`tabs.${tabIndex}`}>
                <ContentSet spacing={SCAFFOLDING.GUTTER}>
                    {!showLoginMessage && (
                        <Suspense fallback={<SmallLoading />}>
                            <SearchOptions
                                handleSearchClicked={() => {
                                    search();
                                }}
                            />
                        </Suspense>
                    )}
                    {!showLoginMessage && (
                        <SearchResults
                            selectedStyle={selectedStyle}
                            {...tab.searchResult}
                            handlePageChange={(page) => {
                                scrollToTop();
                                search(page.selected);
                            }}
                            handleStyleSelected={handleStyleSelected}
                        />
                    )}
                    {showLoginMessage && this.renderLoginMessage()}
                </ContentSet>
            </FormSection>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedStyle: getStyle(state),
    isAuthenticated: currentUserAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    handleStyleSelected: debounce(100, (style, isSelected) => {
        dispatch(isSelected ? clearPreviewStyleAction() : setPreviewStyleAction(style));
    }),
    search: (tabIndex, page) => {
        dispatch(searchAction(tabIndex, page));
    },
    onLoginClick: () => {
        dispatch(showModal(MODAL.LOGIN));
    },
    onRegisterClick: () => {
        dispatch(showModal(MODAL.REGISTER));
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, ownProps, stateProps, dispatchProps, {
        search: (page) => dispatchProps.search(ownProps.tabIndex, page),
        showLoginMessage: ownProps.tab.requiresAuthentication && !stateProps.isAuthenticated,
    });

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SearchTab);
